module.exports = __webpack_public_path__ + "static/media/ueb.cda95bc2.svg";